import set from "lodash.set";
import get from "../get";

const parseAPIErrorFormik = (
  error,
  mappings = {},
  isSingleItem = false,
  customMapperFn
) => {
  let formikError = {};
  const errors = get(error, "response.data", []);

  if (!Array.isArray(errors) || errors.length === 0) {
    return null;
  }

  errors.forEach(({ path, message }) => {
    if (isSingleItem) {
      path = path.replace("[0].", "");
    }
    if (customMapperFn) {
      set(formikError, customMapperFn(path), message);
    } else {
      set(formikError, get(mappings, path, path), message);
    }
  });
  return formikError;
};

export default parseAPIErrorFormik;
